<template>
    <div class="alert alert-light alert-elevate" role="alert">
        <div class="alert-text">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-3">
                    <router-link
                        to="/dashboard/manage-products/view/ingredients"
                        tag="button" class="btn btn-outline-success btn-elevate btn-pill"
                        :class="activeTable === 'IngredientsTable' ? 'active' : ''">
                        {{ labels.view_ingredients | capitalize }}
                    </router-link>
                </div>
                <div class="col-3">
                    <router-link
                        to="/dashboard/manage-products/view/roles"
                        tag="button" class="btn btn-outline-success btn-elevate btn-pill"
                        :class="activeTable === 'RolesTable' ? 'active' : ''">
                        {{ labels.view_roles | capitalize }}
                    </router-link>
                </div>
                <div class="col-3">
                    <router-link
                        to="/dashboard/manage-products/view/related-incis"
                        tag="button" class="btn btn-outline-success btn-elevate btn-pill"
                        :class="activeTable === 'RelatedIncisTable' ? 'active' : ''">
                        {{ labels.view_related_incis | capitalize }}
                    </router-link>
                </div>
                <div class="col-1"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MenuViews',
  watch: {
    $route(value) {
      // Watch when param changes
      this.activeTable = value.name || value.params.name;
    },
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
  },
  data() {
    return {
      activeTable: null,
    };
  },
  mounted() {
    this.activeTable = this.$route.name || this.$route.params.name;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/MenuViews.vue